import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { getAction, httpAction } from '@api/manage';
import IwsUpload from '@comp/upload/IwsUpload';
import pick from 'lodash.pick';
import moment from 'moment';
import { queryUserTreeList } from '@/api/api';
export default {
  name: 'CarAccidentModal',
  mixins: [ModalFormMixin],
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      title: '车辆事故登记表单',
      tableName: 'ea_asset_car_accident',
      form_fields: ['carId', 'location', 'liable', 'userId', 'damage', 'responsibility', 'damageDetails', 'casualties', 'accidentHandle', 'company', 'other', 'remark', 'sort'],
      form_fields_time: ['sdate'],
      validatorRules: {
        carId: {
          rules: [{
            required: true,
            message: '请选择车牌号!'
          }]
        },
        location: {
          rules: [{
            required: true,
            message: '请输入事故地点!'
          }]
        },
        sdate: {
          rules: [{
            required: true,
            message: '请选择事故时间!'
          }]
        },
        liable: {
          rules: [{
            required: true,
            message: '请选择事故责任方!'
          }]
        },
        damage: {
          rules: [{
            required: true,
            message: '请选择车辆损坏程度!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请选择登记人!'
          }]
        }
      },
      url: {
        queryCarCards: '/ea/asset/car/queryCarCards'
      },
      userTree: [],
      //人员信息
      carId: '',
      loginUser: '',
      carCardsList: [],
      disableStatus: false
    };
  },
  props: {
    permissionObj: {
      type: Object,
      default: function _default() {
        edit: '';
      }
    },
    pagePath: String
  },
  created: function created() {
    this.loginUser = this.$store.getters.userInfo.id;
  },
  methods: {
    moment: moment,
    add: function add(carId) {
      this.carId = carId;
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.loadTreeList();
      this.visible = true;
      this.disableStatus = false;

      if (!this.model.userId) {
        this.model.userId = this.loginUser;
        if (this.model.userId != 1) this.superAdminStatus = true;
        this.model.gasolineDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
      }

      this.loadCarCard();
      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields));
        that.form.setFieldsValue({
          sdate: _this.model.sdate ? moment(_this.model.sdate) : null
        });

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        var addTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        var buTime = values.sdate._i;
        var ATime = new Date(addTime).getTime();
        var CTime = new Date(buTime).getTime();

        if (!err || ATime - CTime < 60 * 60 * 1000) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          formData.sdate = formData.sdate ? formData.sdate.format('YYYY-MM-DD') : null;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';
          var headers = {
            tableName: _this2.permissionObj.edit.split(':')[1]
          };

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';

            if (_this2.permissionObj.edit) {
              headers.id = _this2.model.id; // let largePermission = getLargePermission({ value: that.permissionObj.edit })
              // getBindingValue(headers, largePermission)
            }
          }

          httpAction(httpurl, formData, method, headers).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });

              _this2.$refs.iwupload.resetUploadFiles();

              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this3 = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this3.loading = false;
        }
      });
    },
    loadCarCard: function loadCarCard() {
      var that = this;
      that.carCardsList = [];
      getAction(this.url.queryCarCards).then(function (res) {
        if (res.success) {
          that.carCardsList = res.result;
        }
      });
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};